import * as storage from '~/utils/storage';

interface UserCredential {
  user?: any;
  accessToken?: string | null;
}

interface GoogleUserInfo {
  accessToken?: string;
  user?: any;
}

export const authWithGoogle = async () => {
  // try {
  //   const resp = await request.get(API_URL.GET_GOOGLE_AUTH_URL)
  //   const googleAuthURL = resp.data.data.url
  //   window.location = googleAuthURL
  // } catch (e) {
  //   new AppError(e, 'Cannot login using google. Please try again')
  // }
};

export const removeSavedUserInfo = () => {
  storage.remove('EASE_WEB_MEDICAL_ACCESS_TOKEN');
  storage.remove('EASE_WEB_MEDICAL_USER');
};

export const saveUserCredential = async ({accessToken, user}: UserCredential) => {
  if (accessToken) {
    await storage.save('EASE_WEB_MEDICAL_ACCESS_TOKEN', accessToken);
  }
  if (user) {
    await storage.save('EASE_WEB_MEDICAL_USER', user);
  }
};

export const getCurrentUserFromStorage = (): UserCredential => {
  const user = storage.load('EASE_WEB_MEDICAL_USER');
  const accessToken = storage.load('EASE_WEB_MEDICAL_ACCESS_TOKEN');

  return {
    accessToken,
    user,
  };
};
